// extracted by mini-css-extract-plugin
export default {"container":"_7dpR8","containerExtraSpacing":"_3-csN"};